/** Menu-only responsive variants; originals, artwork and crop styles remain unchanged. */
import { SITE } from "@/lib/site";

export const MENU_IMAGES = {
  hero: {
    srcSet: `/manus-storage/fish-amok-menu-landscape-640_2972e4a9.webp 640w, /manus-storage/fish-amok-menu-landscape-960_acbc6532.webp 960w, /manus-storage/fish-amok-menu-landscape-1280_75f1c862.webp 1280w, ${SITE.images.fishAmokRice} 1800w`,
    sizes: "(max-width: 767px) 100vw, (max-width: 1279px) 90vw, 1200px",
  },
  categories: [
    {
      src: SITE.images.fishAmok,
      alt: "Fish Amok in banana leaf, a signature dish at ANGKOR Cambodian Flavours",
      srcSet: `${SITE.images.fishAmok480} 480w, ${SITE.images.fishAmok640} 640w, ${SITE.images.fishAmok960} 960w, ${SITE.images.fishAmok} 1600w`,
    },
    {
      src: SITE.images.betelLeaf,
      alt: "Prawn betel leaf starter at ANGKOR Cambodian Flavours",
      srcSet: `/manus-storage/betel-leaf-prawn-angkor-480_cf0d3cae.webp 480w, /manus-storage/betel-leaf-prawn-angkor-800_978289d8.webp 800w, ${SITE.images.betelLeaf} 1024w`,
    },
    {
      src: SITE.images.salad,
      alt: "Green mango salad at ANGKOR Cambodian Flavours",
      srcSet: `/manus-storage/green-mango-salad-angkor-cambodian-flavours-480_96c1a9df.webp 480w, /manus-storage/green-mango-salad-angkor-cambodian-flavours-800_7b9b71c9.webp 800w, ${SITE.images.salad} 1600w`,
    },
    {
      src: SITE.images.cambodianCurry,
      alt: "Cambodian curry served at ANGKOR Cambodian Flavours",
      srcSet: `/manus-storage/cambodian-curry-premium-480_13688488.webp 480w, /manus-storage/cambodian-curry-premium-800_a6588971.webp 800w, ${SITE.images.cambodianCurry} 1600w`,
    },
    {
      src: SITE.images.dessert,
      alt: "Black rice pudding dessert at ANGKOR Cambodian Flavours",
      srcSet: `/manus-storage/black-sticky-rice-dessert-angkor-480_75a41e89.webp 480w, /manus-storage/black-sticky-rice-dessert-angkor-800_e28e95ca.webp 800w, ${SITE.images.dessert} 1440w`,
    },
  ],
  sectionSizes: "(max-width: 767px) calc(100vw - 40px), 560px",
  bbqSrcSet: `/manus-storage/bbq-beef-premium-480_f929ca83.webp 480w, /manus-storage/bbq-beef-premium-800_da5f438f.webp 800w, ${SITE.images.bbqBeef} 1600w`,
  banquetSrcSet: `/manus-storage/khmer-grill-sharing-platter-angkor-480_17f3d0fb.webp 480w, /manus-storage/khmer-grill-sharing-platter-angkor-800_34550cae.webp 800w, ${SITE.images.khmerGrill} 1122w`,
} as const;
